import * as R from 'ramda'
import { createSelector } from 'reselect'

const userIdSelector = state => state.user.id
const nameSelector = state => state.user.name
const emailSelector = state => state.user.email
const usernameSelector = state => state.user.username
const passwordSelector = state => state.user.password
const authenticatedSelector = state => state.user.authenticated
const isProfileLoadedSelector = state => state.user.profile
const showErrorSelector = state => state.user.showError

export {
  authenticatedSelector,
  userIdSelector,
  usernameSelector,
  passwordSelector,
  nameSelector,
  emailSelector,
  showErrorSelector,
  isProfileLoadedSelector
}
